import AppModal from "@/components/AppModal";
import {
  Box,
  Button,
  Grid2,
  Link,
  Paper,
  Stack,
  Typography,
  useTheme
} from "@mui/material";
import { getAuth, getRedirectResult } from "firebase/auth";
import {firebaseApp} from '@/utils/firebase'
import useMobileDetect from "next-device-detection";
import { useCallback, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { SettingsContext } from "../../../../SettingsProvider";
import InviteLoginForm from "../InviteLoginForm";
import InviteRegisterForm from "../InviteRegisterForm";
import classes from "../css/index.module.less";
import { useNavigate, useSearchParams } from "react-router-dom";
import RouteConstant from "@/constant/RouteConstant";
import OpenOrDownloadApp from "@/components/OpenOrDownloadApp";

function LoginMain({ mode }) {
  const { settings, updateSetting } = useContext(SettingsContext);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const theme = useTheme();
  const detectMobile = useMobileDetect();

  const [isLogin, setIsLogin] = useState(false);
  const [accessToken, setAccessToken] = useState(null);
  const [helpShow, setHelpShow] = useState(false);
  const [showAppStoreModal, setShowAppStoreModal] = useState(true);

  useEffect(() => {
    setIsLogin(mode == 'login');
    _checkRedirectResult();
  }, [mode]);

  useEffect(() => {
    setShowAppStoreModal(true);
  }, [searchParams]);

  const interceptAction = useCallback(() => {
    setShowAppStoreModal(true);
  }, []);

  const _checkRedirectResult = async () => {
    getRedirectResult(getAuth(firebaseApp)).then(result => {
      if (result) {
        result.user.getIdToken().then(token => {
          setAccessToken(token);
        });
        // const credential = GoogleAuthProvider.credentialFromResult(result);
        // const token = credential.idToken;
        // console.log('GoogleAuthProvider credential: ', credential);
      }
    });
  }

  const _toggleHelpShow = () => {
    setHelpShow(!helpShow);
  };

  const _renderRegisterForm = () => {
    return (
      <Box>
        <Box className={classes["title-warp"]}>
          <Box className={classes.title}>{t("register")}</Box>
          <p className={classes.subtitle}>{t("welcome_to_redotpay")}</p>
        </Box>
        <InviteRegisterForm
          accessToken={accessToken}
          onAccessTokenUsed={() => setAccessToken(null)}
          setIsLogin={_setIsLogin}
          interceptAction={interceptAction}
        />
      </Box>
    );
  };

  const _renderLoginForm = () => {
    return (
      <Box>
        <Box className={classes["title-warp"]}>
          <Box className={classes.title}>{t("login")}</Box>
        </Box>
        <InviteLoginForm
          accessToken={accessToken}
          onAccessTokenUsed={() => setAccessToken(null)}
          setIsLogin={_setIsLogin}
          interceptAction={interceptAction}
        />
      </Box>
    );
  };

  const _setIsLogin = (val) => {
    if (!val) return;
    navigate(_getNavLinkSearch(true), {
      replace: true,
    });
    setIsLogin(true);
  }

  const _getNavLinkSearch = (isLogin = false) => {
    let params = new URLSearchParams(window.location.search)
    if (isLogin) {
      params.set('mode', 'login');
    } else {
      params.set('mode', 'register');
    }
    return `${RouteConstant.LOGIN}?${params.toString()}`;
  }

  const _renderForm = () => {
    return isLogin ? _renderLoginForm() : _renderRegisterForm();
  }

  return (
    <>
      {/* {detectMobile.isMobile && ( */}
      <Stack className={`${classes["authFlow-warp"]} ${classes["register-wrap"]}`}>
          {_renderForm()}
        </Stack>
      <OpenOrDownloadApp
        open={showAppStoreModal}
        onClose={() => setShowAppStoreModal(false)}
      />
      <AppModal
        title="Verification code not received？"
        onClose={_toggleHelpShow}
        open={helpShow}
      >
        <Stack sx={{ padding: "24px" }}>
          <Box className={classes.notReceive} color="text.secondary">
            <Typography>{t("we_send_code")}</Typography>
            <ul>
              <li>
                <Typography>{t("check_junk")}</Typography>
              </li>
              <li>
                <Typography>{t("message_may_delay")}</Typography>
              </li>
              <li>
                <Typography>{t("setup_wl")}</Typography>
              </li>
            </ul>
            <Button fullWidth variant="contained" onClick={_toggleHelpShow}>
              {t("confirm")}
            </Button>
          </Box>
        </Stack>
      </AppModal>
    </>
  );
}

export default LoginMain;
